import { HugeiconsIcon } from "@hugeicons/react";
import { Search01Icon, Cancel01Icon } from "@hugeicons/core-free-icons";
import { Button } from "@/components/ui/button";
import { useCompanyStore } from "../stores/companyStore";

const STATUS_OPTIONS = [
  { value: "null", label: "전체" },
  { value: "true", label: "활성" },
  { value: "false", label: "비활성" },
] as const;

function parseIsActive(val: string): boolean | null {
  if (val === "true") return true;
  if (val === "false") return false;
  return null;
}

export function CompanySearchFilter() {
  const searchStr = useCompanyStore((s) => s.searchStr);
  const isActive = useCompanyStore((s) => s.searchParams.isActive);
  const setSearchStr = useCompanyStore((s) => s.setSearchStr);
  const setIsActive = useCompanyStore((s) => s.setIsActive);
  const search = useCompanyStore((s) => s.search);
  const reset = useCompanyStore((s) => s.reset);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") search();
  };

  return (
    <div className="flex flex-shrink-0 flex-wrap items-center gap-2 bg-white px-3 py-2">
      {/* 검색 */}
      <div className="flex items-center">
        <input
          type="text"
          value={searchStr}
          onChange={(e) => setSearchStr(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="업체명, 사업자번호, 전화번호 검색"
          className="h-7 w-48 rounded-l-md border border-r-0 border-gray-300 px-3 text-xs text-gray-700 outline-none focus:border-blue-500 xl:w-64"
        />
        <Button
          size="sm"
          onClick={search}
          className="h-7 rounded-l-none rounded-r-md bg-blue-600 px-3 text-xs font-bold hover:bg-blue-700"
        >
          <HugeiconsIcon icon={Search01Icon} size={14} />
        </Button>
      </div>

      {/* 상태 필터 */}
      <div className="flex items-center gap-1.5">
        <span className="whitespace-nowrap text-xs text-gray-600">상태</span>
        <select
          value={String(isActive)}
          onChange={(e) => setIsActive(parseIsActive(e.target.value))}
          className="h-7 rounded-md border border-gray-300 bg-white px-2 text-xs text-gray-700 outline-none focus:border-blue-500"
        >
          {STATUS_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>

      {/* 초기화 */}
      <Button
        variant="outline"
        size="sm"
        onClick={reset}
        className="ml-2 h-7 border-gray-300 px-3 text-xs font-bold"
      >
        <HugeiconsIcon icon={Cancel01Icon} size={14} className="mr-1" />
        초기화
      </Button>
    </div>
  );
}
